import React, {useState} from 'react';
import {useForm} from '@mantine/hooks';
import {
    TextInput,
    PasswordInput,
    Group,
    Checkbox,
    Button,
    Paper,
    Text,
    LoadingOverlay,
    Anchor,
    useMantineTheme, Title, Divider,
} from '@mantine/core';
import {Lock, Mail} from "tabler-icons-react";
import {useNavigate} from "react-router-dom";

export interface AuthenticationFormProps {
    onSubmit: (values:any) => void,
    style?: React.CSSProperties;
}

function AgentSubmissionUpdate({style, onSubmit}: AuthenticationFormProps) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const theme = useMantineTheme();

    const toggleFormType = () => {
        navigate("/agent/submission")
    };

    const form = useForm({
        initialValues: {
            email: '',
            formPassword: '',
        },

        validationRules: {
            email: (value) => /^\S+@\S+$/.test(value),
        },

        errorMessages: {
            email: 'Invalid email'
        },
    });

    const handleSubmit = async () => {
        setLoading(true);
        setError(null);
        await onSubmit(form.values);
        setLoading(false);
    };

    return (
        <Paper
            p="lg"
            shadow="sm"
            style={{
                position: 'relative',
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
                ...style,
            }}
        >
            <Title order={3}>Agent Submission Update</Title>
            <Divider mt={12}/>
            <form onSubmit={form.onSubmit(handleSubmit)}>
                <LoadingOverlay visible={loading}/>
                <TextInput
                    mt="md"
                    required
                    placeholder="Your email"
                    label="Email"
                    icon={<Mail width={20}/>}
                    {...form.getInputProps('email')}
                />

                <PasswordInput
                    mt="md"
                    required
                    placeholder="Form Password"
                    label="Form Password"
                    icon={<Lock width={20}/>}
                    {...form.getInputProps('formPassword')}
                />

                {error && (
                    <Text color="red" size="sm" mt="sm">
                        {error}
                    </Text>
                )}

                <Group position="apart" mt="xl">
                    <Anchor
                        component="button"
                        type="button"
                        color="gray"
                        onClick={toggleFormType}
                        size="sm"
                    >
                        Haven't submitted an application? Submit one here.
                    </Anchor>
                    <Button color="blue" type="submit">
                        Login
                    </Button>
                </Group>
            </form>
        </Paper>
    );
}

export default AgentSubmissionUpdate;